export enum PanelType {
  Link = 'link',
  EGift = 'egift',
}
